import { useAuth as useAuthPlugin } from '@clickadilla/components/plugins'
import type { AuthUser } from '@/types/auth'

export const useAuth = useAuthPlugin<AuthUser>
